var r=function(r){for(var t=r.split(" "),e="",n=0;n<Math.min(2,t.length);n++)t[n][0]&&(e+=t[n][0]);return e.toUpperCase()};export{r as getAvatarInitials};
//# sourceMappingURL=FGAvatar.logic.js.map
